import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

document.querySelectorAll(".cards-stacker").forEach((stacker) => {
    const cards = gsap.utils.toArray(stacker.querySelectorAll(".cards-stacker__item"));
    if (cards.length === 0) return;

    const lastTrigger = ScrollTrigger.create({
        trigger: cards[cards.length - 1],
        start: "center center",
    });

    ScrollTrigger.create({
        trigger: cards[0],
        start: "center center",
    });

    // Get numbersContainer (remains where it is)
    const numbersContainer = stacker.querySelector(".cards-stacker__numbers");
    const numberButtons = [];

    ScrollTrigger.create({
        trigger: stacker,
        start: "top top+=100",
        end: "bottom 50%+=100px",
        pin: numbersContainer,
        pinSpacing: false,
    });

    function updateActiveCard(activeIndex) {
        numberButtons.forEach((btn, idx) => {
            if (idx === activeIndex) {
                btn.classList.add("active-card");
                btn.classList.remove("inactive-card");
            } else {
                btn.classList.remove("active-card");
                btn.classList.add("inactive-card");
            }
        });
    }

    // Create a button for each card
    cards.forEach((card, i) => {
        const btn = document.createElement("span");
        btn.classList.add("card-number");
        btn.textContent = `0${i + 1}`;
        numbersContainer.appendChild(btn);
        numberButtons.push(btn);

        ScrollTrigger.create({
            trigger: card,
            start: "top center",
            end: "bottom center",
            onEnter: () => updateActiveCard(i),
            onLeaveBack: () => updateActiveCard(i - 1),
        });
    });

    // Create and append SKIP button as last element
    const skipButton = document.createElement("button");
    skipButton.classList.add("cards-stacker__skip");
    skipButton.textContent = "Skip";
    skipButton.addEventListener("click", () => {
        const lastCard = cards[cards.length - 1];
        const targetY = lastCard.getBoundingClientRect().top + window.pageYOffset + lastCard.offsetHeight;
        gsap.to(window, { scrollTo: { y: targetY, autoKill: true }, duration: 1 });
    });
    numbersContainer.appendChild(skipButton);


    cards.forEach((card, i) => {
        let scaleValue;
        if (cards.length > 1) {
            scaleValue = 1 - 0.1 * ((cards.length - 1 - i) / (cards.length - 1));
        } else {
            scaleValue = 1;
        }
        const tween = gsap.to(card, {
            scale: scaleValue,
            transformOrigin: "50% center",
        });
        ScrollTrigger.create({
            trigger: card,
            start: "top " + (10 + 30 * i) + "px",
            end: () => lastTrigger.start + 50,
            pin: true,
            pinSpacing: false,
            ease: "none",
            animation: tween,
            toggleActions: "restart none none reverse",
        });
    });
});
